import { render, staticRenderFns } from "./ListCompleteWarrantyStock.vue?vue&type=template&id=2622ba42&"
import script from "./ListCompleteWarrantyStock.vue?vue&type=script&lang=js&"
export * from "./ListCompleteWarrantyStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports